import { useTheme } from '@simplywallst/ui-core';
import { Title } from './styled';

interface Props {
  x: number;
  width: number;
  labels?: {
    first: string;
    second: string;
  };
}

const XAxis = ({
  x,
  width,
  labels = {
    first: 'Shares sold',
    second: 'Shares bought',
  },
}: Props) => {
  const theme = useTheme();
  return (
    <svg x={x} y="0" width={width} height="100%">
      <rect
        x="0"
        y="0"
        width="50%"
        height="100%"
        fill={theme.color.warning}
        fillOpacity="0.1"
      />
      <rect
        x="50%"
        y="0"
        width="50%"
        height="100%"
        fill={theme.color.good}
        fillOpacity="0.1"
      />
      <Title
        x={width / 2 - 8}
        y="20"
        color={theme.color.warning}
        dominantBaseline="middle"
        textAnchor="end"
      >
        {labels.first}
      </Title>
      <Title
        x={width / 2 + 8}
        y="20"
        color={theme.color.good}
        dominantBaseline="middle"
        textAnchor="start"
      >
        {labels.second}
      </Title>
    </svg>
  );
};

export default XAxis;
